$(document).on('click', '.js-showPasswordContent', function() {
  const parent = $(this).parents('.js-passwordForm')

  parent.toggleClass('is_show');
  parent.find('.js-passwordContent').slideToggle(200);
});